import { axiosPublicClient } from "../axiosClient";

export const sharedApi = {
  resendVerificationEmail: async (email: string, turnstileToken: string): Promise<void> => {
    await axiosPublicClient.post("/portal/public/resend-verification-email", { 
      email,
      turnstileToken,
      "cf-turnstile-response": turnstileToken,
    });
  },
};
